import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { createStore, select, withProps } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { QuestionType } from '../models/question/question-type.model';
import { EgreementSigneringStatus } from './signering.service';

const store = createStore(
  { name: 'sections-service' },
  withProps<SectionQuestionsState>({
    sectionsStates: [],
  }),
);

@Injectable({
  providedIn: 'root',
})
export class SectionStateService {
  sectionStates$: Observable<SectionState[]> = store.pipe(
    select(
      (state: SectionQuestionsState): SectionState[] => state.sectionsStates,
    ),
  );

  getSectionStateById(sectionId: string): SectionState {
    return store.query((state: SectionQuestionsState): SectionState => {
      return state.sectionsStates.find(
        (section: SectionState) => section.id === sectionId,
      );
    });
  }

  getSectionStateByQuestionId(questionId: string): SectionState {
    return store.query((state: SectionQuestionsState): SectionState => {
      return state.sectionsStates.find((section: SectionState) =>
        section.questions.some((q: SectionQuestion) => q.id === questionId),
      );
    });
  }

  getSectionStateByQuestionType(questionType: string): SectionState {
    return store.query((state: SectionQuestionsState): SectionState => {
      return state.sectionsStates.find((section: SectionState) =>
        section.questions.some((q: SectionQuestion) => q.type === questionType),
      );
    });
  }

  update(newSectionState: SectionState): void {
    store.update((current: SectionQuestionsState) => ({
      ...current,
      sectionsStates: current.sectionsStates.map(
        (currentSectionState: SectionState): SectionState =>
          currentSectionState.id === newSectionState.id
            ? newSectionState
            : currentSectionState,
      ),
    }));
  }

  initSectionState(sectionId: string, questions: SectionQuestion[]): void {
    const existingSection = this.getSectionStateById(sectionId);
    if (!existingSection) {
      const newSection: SectionState = {
        id: sectionId,
        questions: questions,
        expanded: false,
      };
      store.update((state: SectionQuestionsState) => ({
        ...state,
        sectionsStates: [...state.sectionsStates, newSection],
      }));
    }
  }

  getExpandedById(sectionId: string): boolean {
    const section = this.getSectionStateById(sectionId);
    return section ? section.expanded : false;
  }

  updateStateByRouteParams(params: Params): void {
    if (
      params[QueryParamNames.EgreementStatus] ===
      EgreementSigneringStatus.Success
    ) {
      const stateToUpdate = this.getSectionStateByQuestionType(
        QuestionType.Signering,
      );
      stateToUpdate.expanded = true;
      this.update(stateToUpdate);
    }
  }
}

export interface SectionQuestionsState {
  sectionsStates: SectionState[];
}

export interface SectionState {
  id: string;
  questions: SectionQuestion[];
  expanded: boolean;
}

export interface SectionQuestion {
  id: string;
  type: string;
}

export enum QueryParamNames {
  EgreementStatus = 'EgreementStatus',
}
